import * as Redux from 'redux'
import * as Request from '../../../request'
import * as Constants from './constants'

type FetchFeaturesFn = (str: string) => Redux.Action

export const fetchErrors: FetchFeaturesFn = (id: string) =>
    Request.requestActionCreator(Constants.FETCH_ERRORS)
      ({
        method: 'GET',
        url: `${Constants.SERVER_RESOURCE}/${id}`,
      })



// WEBPACK FOOTER //
// ./src/pages/imports/errors/actions.ts